'use client';

import Conjugator from '@/components/Conjugator';


export default function ConjugatorPage() {
  
  return (
    <>
    <Conjugator isOpen={true}/>
    </>
  );
}
